import { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, Formulario } from "../../../shared";
import { Toast } from "primereact/toast";

export default function FormularioNuevoProcesoCliente({
  clienteId,
  onProcesoCreado
}) {
  const [formLoader, setFormLoader] = useState(false);
  const toast = useRef(null);
  const navigate = useNavigate();

  function crearProcesoSubmit(camposFormulario) {
    setFormLoader(true);
    // Agregar clienteId al payload antes de enviar
    const payload = {
      ...camposFormulario,
      clienteid: clienteId
    };
    accessAPI(
      "POST",
      "admin/proceso",
      payload,
      (respuesta) => {
        setFormLoader(false);
        if (onProcesoCreado) {
          onProcesoCreado(respuesta);
        } else {
          navigate(`/proceso/${respuesta.id}`);
        }
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0].msg,
          sticky: true
        });
      }
    );
  }

  const formConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "nombrefantasia",
            tipoitemformularioid: 1,
            etiqueta: "Nombre del proceso",
            requerido: true
          },
          {
            nombre: "certificadotipoid",
            tipoitemformularioid: 5,
            etiqueta: "Tipo de certificado",
            requerido: true,
            opciones: "admin/config/certificadotipo?disponibleproceso=true",
            sinOpcionInicial: true
          },
          {
            nombre: "esquemaid",
            tipoitemformularioid: 5,
            etiqueta: "Esquema de certificación",
            requerido: true,
            opciones: "admin/config/esquema",
            sinOpcionInicial: true,
            queryparams: ["certificadotipoid"]
          },
          {
            nombre: "normaid",
            tipoitemformularioid: 5,
            etiqueta: "Norma",
            requerido: true,
            opciones: "admin/norma",
            sinOpcionInicial: true,
            queryparams: ["certificadotipoid"]
          },
          {
            nombre: "sitioFabricaId",
            tipoitemformularioid: 5,
            etiqueta: "Sitio fábrica",
            opciones: `admin/proceso/fabricas?clienteid=${clienteId}`,
            sinOpcionInicial: true
          },
          {
            nombre: "sitioFabricanteId",
            tipoitemformularioid: 5,
            etiqueta: "Sitio fabricante",
            opciones: `admin/proceso/fabricantes?clienteid=${clienteId}`,
            sinOpcionInicial: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Crear proceso",
        callback: crearProcesoSubmit,
        validar: true
      }
    ]
  };

  return (
    <>
      <Toast ref={toast} position="top-center" />
      <Formulario config={formConfig} loader={formLoader} />
    </>
  );
}
